export const O3O_VESSEL_SURVEY_MEASUREMENTS = 'components/O3oVesselSurveyMeasurements';

export const i18n = {
  en: {
    labels: {
      all: 'All',
      noData: 'No data',
      heightInMetres: 'Height in metres',
      totalWeightDisplacement: 'Total Weight Displacement (TWD)',
      twd: 'TWD',
      trim: 'Trim',
      listToStb: 'List to Stb',
    },
    tooltips: {
      expand: 'Expand',
    },
    symbols: {
      meter: 'm',
      tonne: 't',
      hour: 'h',
    },
  },
};
